import { Box } from '@mui/material';
import React from 'react';

export default function InfiniteMarquee() {
  const images = [
    '/images/img_mood_angry.png',
    '/images/img_mood_blank.png',
    '/images/img_mood_bored.png',
    '/images/img_mood_burned_out.png',
    '/images/img_mood_busy.png',
    '/images/img_mood_eating.png',
    '/images/img_mood_excited.png',
    '/images/img_mood_happy.png',
    '/images/img_mood_hot.png',
    '/images/img_mood_joyful.png',
    '/images/img_mood_lonely.png',
    '/images/img_mood_sad.png',
    '/images/img_mood_sick.png',
    '/images/img_mood_surprised.png',
    '/images/img_mood_thinking.png',
    '/images/img_mood_thrilled.png',
    '/images/img_mood_touched.png',
  ];

  const repeat = 2;
  const imgs = Array(repeat).fill(images).flat();

  // 이미지 개수, width, gap 미리 지정 (수정 가능)
  const IMG_WIDTH_MOBILE = 74;
  const IMG_WIDTH_PC = 156;
  const GAP_MOBILE = 30;
  const GAP_PC = 40;
  const IMG_COUNT = images.length;
  const ONE_SET_WIDTH_MOBILE = IMG_COUNT * IMG_WIDTH_MOBILE + (IMG_COUNT - 1) * GAP_MOBILE;
  const ONE_SET_WIDTH_PC = IMG_COUNT * IMG_WIDTH_PC + (IMG_COUNT - 1) * GAP_PC;

  return (
    <Box
      sx={{
        width: '100vw',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: 'max-content',
          animation: `marquee 40s linear infinite`,
          gap: { xs: GAP_MOBILE + 'px', sm: GAP_PC + 'px' },
          '@keyframes marquee': {
            xs: {
              '0%': { transform: 'translateX(0)' },
              '100%': {
                transform: `translateX(-${ONE_SET_WIDTH_MOBILE}px)`,
              },
            },
            sm: {
              '0%': { transform: 'translateX(0)' },
              '100%': {
                transform: `translateX(-${ONE_SET_WIDTH_PC}px)`,
              },
            },
          },
        }}
      >
        {imgs.map((src, i) => (
          <Box
            key={i}
            component="img"
            src={src}
            alt=""
            sx={{
              width: { xs: IMG_WIDTH_MOBILE, sm: IMG_WIDTH_PC },
              height: 'auto',
              flexShrink: 0,
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
